<template>
  <span>
    <sidebar-row v-for="(item, index) in computedItems" :key="index" class="my-3">
      <template #actionIcon>
        <v-row no-gutters class="justify-center">
          <v-col cols="auto" :class="index !== 0 ? 'ladder' : ''">
            <div class="outSideIcon">
              <v-icon color="#fff" small> {{ item.icon }}</v-icon>
            </div>
          </v-col>
        </v-row>
      </template>
      <template #default>
        <v-row no-gutters>
          <v-col cols="auto">
            <v-tooltip bottom color="font">
              <template #activator="{ on }">
                <div class="pl-1 text-left justDate" v-on="on">
                  {{ item.date }}<span class="dateText">{{ item.time }}</span>
                </div>
              </template>
              {{ item.tooltipText }}
            </v-tooltip>
          </v-col>
        </v-row>
      </template>
    </sidebar-row>
  </span>
</template>

<script>
import SidebarRow from '@/components/SidebarRow';

export default {
  name: 'ZDMFailuresDateHistory',
  components: { SidebarRow },
  props: {
    dates: {
      type: Object,
      default: () => {},
    },
  },
  computed: {
    computedItems() {
      return Object.keys(this.dates).map(key => {
        return {
          ...key,
          icon: this.getItemIcon(key),
          tooltipText: this.getTooltipText(key),
          date: this.dateText(this.dates[key]),
          time: this.getTime({ key, value: this.dates[key] }),
        };
      });
    },
  },
  methods: {
    getTimeDiff(value, previous) {
      return this.$dayjs(value).diff(this.dates[previous]);
    },
    getTimeDiffText(diff) {
      const dayString =
        this.$dayjs.duration(diff).days() + ` ${this.$i18n.tc('default.days', this.$dayjs.duration(diff).days())}`;
      const hourString =
        this.$dayjs.duration(diff).hours() + ` ${this.$i18n.tc('default.hours', this.$dayjs.duration(diff).hours())}`;
      const minuteString =
        this.$dayjs.duration(diff).minutes() +
        ` ${this.$i18n.tc('default.minutes', this.$dayjs.duration(diff).minutes())}`;
      const secondString =
        this.$dayjs.duration(diff).seconds() +
        ` ${this.$i18n.tc('default.seconds', this.$dayjs.duration(diff).seconds())}`;
      const timeArray = [
        ...(this.$dayjs.duration(diff).days() === 0 ? [] : [dayString]),
        ...(this.$dayjs.duration(diff).hours() === 0 ? [] : [hourString]),
        ...(this.$dayjs.duration(diff).minutes() === 0 ? [] : [minuteString]),
        ...(this.$dayjs.duration(diff).seconds() === 0 ? [] : [secondString]),
      ];
      const timeString = timeArray.join(', ');
      return timeString === '' ? '' : ` (+${timeString})`;
    },
    getTime(obj) {
      const { key, value } = obj;
      if (key === 'dateAccepted') {
        return '';
      } else if (key === 'dateForwarded') {
        return this.getTimeDiffText(this.getTimeDiff(value, 'dateAccepted'));
      } else if (key === 'dateConfirmed') {
        return this.getTimeDiffText(this.getTimeDiff(value, 'dateForwarded'));
      }
    },
    getTooltipText(key) {
      return this.$i18n.t(`sidebar.zdm_failuresModule.${key}`);
    },
    dateText(value) {
      if (value === undefined) {
        return this.$i18n.t('admin.noData');
      } else {
        return this.$dayjs(value).format('L LTS');
      }
    },
    getItemIcon(key) {
      if (key === 'dateAccepted') {
        return 'mdi-arrow-left-bold';
      } else if (key === 'dateForwarded') {
        return 'mdi-arrow-right-bold';
      } else if (key === 'dateConfirmed') {
        return 'mdi-check';
      }
    },
  },
};
</script>

<style scoped lang="scss">
.outSideIcon {
  background: #0091ea;
  box-shadow: 0 1px 5px 0 #0000001f, 0 2px 2px 0 #00000024, 0 1px 1px 0 #00000033;

  display: flex;
  align-items: center;
  justify-content: center;
  border: 4px solid white;
  position: relative;
  z-index: 1;
  border-radius: 50%;
  height: 34px;
  width: 34px;
}

.ladder {
  position: relative;

  :after {
    content: '';
    height: 65%;
    position: absolute;
    z-index: 0;
    bottom: 100%;
    left: calc(50% - 1px);
    border-left: 2px solid rgba(0, 0, 0, 0.12);
  }
}
.justDate {
  font-family: Roboto;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 16px;
  letter-spacing: 0em;
  text-align: left;
  color: #202124;
}
.dateText {
  font-family: Roboto;
  font-size: 12px;
  font-style: normal;
  font-weight: 500;
  line-height: 14px;
  letter-spacing: 0em;
  text-align: left;
  color: #00000096;
}
</style>
